import useCommentDialog from 'components/CommentDialog/useCommentDialog';
import useDialog from 'components/ConfirmDialog/useDialog';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { getItem } from 'storage';
import { getStore } from 'store';
import { setGlobal, setGlobalLoading } from 'store/global/reducer';
import {
    SAVE_REMOTE_APPLICATION_DETAIL,
    UPDATE_APPLICATION_FORM_DETAIL_VALID_STATE,
    UPDATE_APPLICATION_STATUS_WITH_DETAIL,
} from 'store/key';
import { checkFormValid, returnCondition } from 'utility/formValidate';
import {
    AMEND_FORM_SAVE_SUCCESS,
    COMPARE_CHANGE_TIPS,
    COMPARE_CHANGE_REMINDER,
    CONFIRM_TO_SAVE_AMENDMENT,
    GENERAL_RETURN_SUCCESS,
    CONFIRM_RETURN_TO_CLUSTER_ADMIN,
    GENERAL_RETURN_TO_CLUSTER_ADMIN,
    CONFIRM_AMENDMENT,
    CONFIRM_APPLICATION_SUCCESS,
    CHECK_FORM_COMPLETENESS,
    DISCARD_CONFIRM,
    CHANGES_DETECTED,
    AMENDMENT_RETURN_TIPS,
} from 'utility/frontendMessage';
import {
    amendmentClearMessage,
    checkCIAmendment,
    generateRandomId,
    getFolderDisplayPath,
    hasAmendmentDetails,
    isFormChanged,
    isSiteAddedInAmendment,
    publish,
} from 'utility/general';
import {
    APPLICANT,
    DRAFT,
    CCO,
    CLUSTER_ADMIN,
    DISTRIBUTED,
    REVIEWED,
    SECRETARY,
    SUBMITTED,
    VERIFIED,
    RE_SUBMITTED,
    CONFIRMED,
    FOR_REVIEW,
    RETURN_FROM_IRB,
    RETURNED,
    HO_ADMIN,
    TAB_AMENDMENT,
    IRB,
    statusLookup,
    TAB_STUDY,
    TAB_SITE,
    REVIEWER,
    TAB_COMMENT,
    TAB_CONSOLIDATION,
    TAB_REVIEWER_COMMENT,
    KEY_PATHNAME,
    TAB_MEETINGARRANGE,
} from 'utility/lookup';
import useApplicationBarAction from './useApplicationBarAction';
import useSubscribe from './useSubscribe';

const useAmendmentButton = ({
    applicationDetail = {},
    siteInfoId,
    amendId,
    amendmentType,
    isAmendmentEdit,
    isAmendmentCreate,
    tabType,
    signedFormId,
    currentTabKey,
    documentType,
    hasPermission, // permission of applicant
    backToStudyInfo = () => null,
}) => {
    const userRole = useSelector((state) => state.user.role);
    const user = useSelector((state) => state.user);
    const showCommentDialog = useCommentDialog();
    const showDialog = useDialog();
    const dispatch = useDispatch();
    const history = useHistory();
    const formId = applicationDetail.applicationForm.id;
    const statusId = applicationDetail.status.statusId;
    const postApprovalFolder = useSelector((state) => state.postApproval.folder || 'all');
    const applicationButtons = useApplicationBarAction({
        applicationDetail,
        tabType,
        statusId,
        siteInfoId,
        isAmendment: true,
        currentTabKey,
        documentType,
    });

    let result = [];

    const isStudyAmendment = applicationDetail?.applicationForm?.underAmendment;
    const isSiteAmendment = !isStudyAmendment;
    let siteToAmend = '';

    if (isSiteAmendment) {
        const id = applicationDetail.siteInfo.find((item) => item.underAmendment)?.id;
        siteToAmend = id;
    }

    const getCloseLabel = () => {
        if (tabType === TAB_SITE || tabType === TAB_STUDY) {
            return 'Close';
        } else {
            return 'Back to study info';
        }
    };

    const getApplicationButton = (buttonName) => {
        const result = applicationButtons.raw.find((item) => {
            return item.tag === buttonName;
        });

        return result;
    };

    const returnAmendment = async () => {
        if (statusId === VERIFIED) {
            const { submit, comment, fileIds } = await showCommentDialog({
                title: CONFIRM_RETURN_TO_CLUSTER_ADMIN,
                placeholder: 'Leave your comments (if any)',
                isRequired: false,
                showUploadButton: true,
            });

            if (!submit) {
                return;
            }

            setGlobalLoading(true);

            // applicationDetail.applicationForm

            dispatch({
                type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
                payload: {
                    id: formId,
                    status: DISTRIBUTED,
                    currentStatus: statusId,
                    hasCCOAction: true,
                    details: [
                        {
                            comment,
                            uploadTempId: fileIds,
                        },
                    ],
                    updateApplicationDetail: true,
                    callback: async () => {
                        await showDialog({
                            description: GENERAL_RETURN_TO_CLUSTER_ADMIN,
                            disableCancelButton: true,
                        });
                    },
                    final: () => {
                        setGlobalLoading(false);
                    },
                },
            });
        } else {
            const { submit, comment, expiryDate, fileIds } = await showCommentDialog({
                title: AMENDMENT_RETURN_TIPS,
                placeholder: 'Leave your comments (if any)',
                isRequired: true,
                showExpiryDate: true,
                defaultExpiryDate: '',
                showUploadButton: true,
            });

            if (!submit) {
                return;
            }

            setGlobalLoading(true);

            // 2 === studyInfo, 1 === siteInfo
            const type = applicationDetail.applicationForm.underAmendment ? 2 : 1;
            let value = '';

            if (type === 2) {
                value = applicationDetail.applicationForm.id;
            } else {
                applicationDetail.siteInfo.forEach((item) => {
                    if (item.underAmendment) {
                        value = item.id;
                    }
                });
            }

            dispatch({
                type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
                payload: {
                    id: formId,
                    status: RETURNED,
                    currentStatus: statusId,
                    hasCCOAction: true,
                    expiryDate: new Date(expiryDate),
                    details: [
                        {
                            comment,
                            uploadTempId: fileIds,
                            type,
                            value,
                        },
                    ],
                    // updateApplicationDetail: true,
                    callback: () => {
                        showDialog({
                            description: GENERAL_RETURN_SUCCESS,
                            disableCancelButton: true,
                        });

                        history.push('/');
                    },
                    final: () => {
                        setGlobalLoading(false);
                    },
                },
            });
        }
    };

    const confirmAmendment = async () => {
        const { submit, comment, fileIds } = await showCommentDialog({
            title: CONFIRM_AMENDMENT,
            placeholder: 'Leave your comments (if any)',
            isRequired: false,
            showUploadButton: true,
        });
        if (!submit) {
            return;
        }
        setGlobalLoading(true);
        dispatch({
            type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
            payload: {
                id: formId,
                status: CONFIRMED,
                currentStatus: statusId,
                hasCCOAction: true,
                details: [
                    {
                        comment,
                        uploadTempId: fileIds,
                    },
                ],
                // updateApplicationDetail: true,
                callback: async () => {
                    // redirect to dashboard
                    history.push('/');

                    await showDialog({
                        description: CONFIRM_APPLICATION_SUCCESS,
                        disableCancelButton: true,
                    });
                },
                final: () => {
                    setGlobalLoading(false);
                },
            },
        });
    };

    const saveAmendmentForm = async (disableConfirm = false, callback = () => null) => {
        const result = checkFormValid(applicationDetail, isStudyAmendment, isSiteAmendment, siteToAmend);

        if (!result.isFormValid) {
            return showDialog({
                title: CHECK_FORM_COMPLETENESS,
                disableCancelButton: true,
                messages: result.messages,
            });
        }

        setGlobalLoading(true);

        const isNewlyAdded = isSiteAddedInAmendment(applicationDetail, siteInfoId);

        if (!isNewlyAdded) {
            const hasAmendmentBefore = await hasAmendmentDetails(formId);

            if (hasAmendmentBefore) {
                setGlobalLoading(false);
                if (!disableConfirm) {
                    const messages = [];

                    messages.push(COMPARE_CHANGE_TIPS);
                    messages.push(<div style={{ marginTop: 15 }} />);
                    messages.push(amendmentClearMessage);

                    const isConfirm = await showDialog({
                        description: CONFIRM_TO_SAVE_AMENDMENT,
                        messages,
                    });

                    if (!isConfirm) {
                        return;
                    }
                }
            }
        }

        dispatch({
            type: UPDATE_APPLICATION_FORM_DETAIL_VALID_STATE,
            payload: {
                clickedSave: true,
            },
        });

        setGlobalLoading(true);

        dispatch({
            type: SAVE_REMOTE_APPLICATION_DETAIL,
            payload: {
                id: formId,
                tabType,
                callback: async () => {
                    if (!disableConfirm) {
                        showDialog({
                            description: AMEND_FORM_SAVE_SUCCESS,
                            disableCancelButton: true,
                        });
                    }

                    callback?.();
                },
                final: () => {
                    setGlobalLoading(false);
                },
            },
        });
    };

    useSubscribe('saveAmendment', saveAmendmentForm);

    result = [
        getApplicationButton('consolidation-save'),
        getApplicationButton('consolidation-confirm'),
        getApplicationButton('download-approval-letter'),
        getApplicationButton('print'),
        {
            text: 'Save',
            isDisabled: () => {
                if (tabType === TAB_AMENDMENT) {
                    return true;
                }

                return false;
            },
            status: [DRAFT, RETURNED],
            condition: () => {
                if (!tabType) {
                    return false;
                }

                if (tabType === TAB_COMMENT) {
                    return false;
                }

                // case of view permission
                if (userRole === APPLICANT && !hasPermission) {
                    return false;
                }

                const isCI = checkCIAmendment(applicationDetail, user.detail);

                // if user is in study tab, show the save button if user is ci, otherwise, hidden the button
                if (tabType === TAB_STUDY) {
                    return isCI;
                } else if (tabType === TAB_SITE) {
                    // case of site

                    const currentSite = applicationDetail.siteInfo.find((item) => {
                        return item.id === siteInfoId;
                    });

                    // check the site is newly added in the amendment form
                    const isNewlyAdded = isSiteAddedInAmendment(applicationDetail, siteInfoId);

                    // case when the site is
                    if (currentSite?.underAmendment) {
                        if (isNewlyAdded) {
                            if (currentSite.status === 1) {
                                return false;
                            } else {
                                return true;
                            }
                        } else {
                            return true;
                        }
                    } else {
                        return false;
                    }
                }

                return isAmendmentEdit;
            },
            action: saveAmendmentForm,
            showInRoles: [APPLICANT],
            disableConfirm: true,
        },
        {
            text: 'Compare change',
            status: statusLookup.map((item) => item.key),
            condition: () => {
                if (tabType === TAB_AMENDMENT) {
                    return false;
                }

                // case of view permission
                if (userRole === APPLICANT && !hasPermission) {
                    return false;
                }

                // disable new site pi compare change function
                if (statusId === DRAFT || statusId === RETURNED) {
                    if (isStudyAmendment) {
                        const isCI = checkCIAmendment(applicationDetail, user.detail);

                        if (!isCI) {
                            return false;
                        }
                    }
                }

                return true;
            },
            action: async () => {
                const store = getStore();

                // if role is applicant, check if the form is valid to compare
                if (user.role === APPLICANT) {
                    const result = checkFormValid(applicationDetail, isStudyAmendment, isSiteAmendment, siteToAmend);

                    if (!result.isFormValid) {
                        return showDialog({
                            title: CHECK_FORM_COMPLETENESS,
                            disableCancelButton: true,
                            messages: result.messages,
                        });
                    }

                    const isChange = await isFormChanged();

                    if (isChange) {
                        // validation will only work on one tab only

                        // setGlobalLoading(true);
                        // const hasAmendmentBefore = await hasAmendmentDetails(formId);
                        // setGlobalLoading(false);

                        // if (hasAmendmentBefore) {
                        //     const messages = [];
                        //     messages.push(amendmentClearMessage);
                        //     const confirm = await showDialog({
                        //         description: COMPARE_CHANGE_TIPS,
                        //         messages,
                        //     });

                        //     if (!confirm) {
                        //         return;
                        //     }
                        // } else {
                        //     const confirm = await showDialog({
                        //         description: CHANGES_DETECTED,
                        //     });

                        //     if (!confirm) {
                        //         return;
                        //     }
                        // }

                        const confirm = await showDialog({
                            description: COMPARE_CHANGE_REMINDER,
                        });
                        if (!confirm) {
                            return;
                        }

                        setGlobalLoading(true);

                        dispatch({
                            type: SAVE_REMOTE_APPLICATION_DETAIL,
                            payload: {
                                id: formId,
                                tabType,
                                callback: async () => {
                                    store.dispatch(
                                        setGlobal({
                                            compareChangeKey: generateRandomId(),
                                        }),
                                    );
                                },
                                final: () => {
                                    setGlobalLoading(false);
                                },
                            },
                        });
                    } else {
                        store.dispatch(
                            setGlobal({
                                compareChangeKey: generateRandomId(),
                            }),
                        );
                    }
                } else {
                    store.dispatch(
                        setGlobal({
                            compareChangeKey: generateRandomId(),
                        }),
                    );
                }
            },
            showInRoles: [APPLICANT],
            disableConfirm: true,
            showInTab: [TAB_STUDY, TAB_SITE],
        },
        getApplicationButton('confirm-request-for-return'),
        getApplicationButton('distribute'),
        getApplicationButton('verify'),
        getApplicationButton('reject-request-for-return'),
        // getApplicationButton('confirm'),
        {
            text: 'Confirm',
            status: [SUBMITTED, VERIFIED, RE_SUBMITTED, DISTRIBUTED],
            action: async () => {
                confirmAmendment();
            },
            condition: () => {
                let isValid = true;

                if (statusId === CONFIRMED) {
                    isValid = false;
                }

                if (statusId === DISTRIBUTED && userRole !== SECRETARY) {
                    isValid = false;
                }

                return isValid;
            },
            showInRoles: [CCO, SECRETARY],
        },
        // getApplicationButton('return'),
        {
            text: 'Return',
            status: [SUBMITTED, RE_SUBMITTED, FOR_REVIEW, REVIEWED, VERIFIED, DISTRIBUTED, RETURN_FROM_IRB, CONFIRMED],
            condition: () => returnCondition(userRole, statusId),
            action: async () => {
                returnAmendment();
            },
            showInRoles: [CCO, SECRETARY, CLUSTER_ADMIN],
            showInTab: [TAB_STUDY, TAB_SITE, TAB_AMENDMENT],
        },
        getApplicationButton('return-from-irb'),
        getApplicationButton('withdraw'),
        getApplicationButton('return-to-site'),
        getApplicationButton('send-to-ci'),
        getApplicationButton('terminate'),
        {
            text: 'Download signed amendment form',
            showInRoles: [CCO, IRB, SECRETARY, CLUSTER_ADMIN, HO_ADMIN, REVIEWER],
            condition: () => {
                return tabType === TAB_AMENDMENT;
            },
            action: async () => {
                publish({ topic: 'downloadSignedAmendment' });
            },
            disableConfirm: true,
        },
        getApplicationButton('reviewer-confirm-review-result'),
        {
            text: getCloseLabel(),
            // status: [],
            action: async () => {
                let confirm = true;

                const isFormUpdated = await isFormChanged();

                if (isFormUpdated) {
                    const isConfirm = await showDialog({
                        description: DISCARD_CONFIRM,
                    });

                    if (!isConfirm) {
                        return;
                    }
                }

                // removed
                // if (statusId === APPLICANT) {
                //     confirm = await showDialog({
                //         description: CONFIRM_TO_LEAVE_AMENDMENT,
                //     });
                // }

                if (confirm) {
                    if (
                        [
                            TAB_AMENDMENT,
                            TAB_COMMENT,
                            TAB_CONSOLIDATION,
                            TAB_REVIEWER_COMMENT,
                            TAB_MEETINGARRANGE,
                        ].includes(tabType)
                    ) {
                        backToStudyInfo();
                    } else if (getItem(KEY_PATHNAME) === '/search') {
                        dispatch(
                            setGlobal({
                                isDetailBack: true,
                            }),
                        );
                        return history.push('/search');
                    } else if (tabType === TAB_SITE || tabType === TAB_STUDY) {
                        const url = getFolderDisplayPath(userRole, statusId);
                        let extraQuery = '';

                        if (`/${postApprovalFolder}` !== url) {
                            extraQuery = '?page=1';
                        }

                        history.push(`/post-approval-document${url}${extraQuery}`);
                    }
                }
            },
            type: 'cancel',
            // showInRoles: [APPLICANT],
            disableConfirm: true,
        },
    ];

    return result.filter((item) => {
        // if showInRoles is not specified, show in all roles
        if (!item.showInRoles) {
            return true;
        }

        // if(item.text === 'Print'){
        //     console.log('142314 useAmendmentButton.js item', item)
        // }

        return item?.showInRoles?.includes(userRole);
    });
};

export default useAmendmentButton;
